// 失败明细和批量预览
export const failColumn = [{
  slots: {
    title: '产品名称'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center',
  className: 'td-bg'
}, {
  slots: {
    title: '方案名称'
  },
  dataIndex: 'planName',
  key: 'planName',
  align: 'center',
  className: 'td-bg'
}
// {
//   slots: {title: '操作'},
//   dataIndex: 'action',
//   key: 'action',
//   scopedSlots: {customRender: 'action'},
//   align: 'center',
//   width: 180,
//   className: 'td-bg'
// }
];
export const COLUMNSPLAN = [{
  slots: {
    title: '方案名称'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center',
  width: 200
},
// {slots: {title: '方案代码'}, dataIndex: 'code', key: '1', align: 'center'},
{
  slots: {
    title: '保障金额'
  },
  dataIndex: 'amount',
  key: 'amount',
  align: 'center',
  width: 200
}, {
  slots: {
    title: '保障权益'
  },
  dataIndex: 'rights',
  key: 'rights',
  align: 'left',
  scopedSlots: {
    customRender: 'rights'
  }
  // children: [
  //   {
  //     title: '权益名称',
  //     dataIndex: 'rightsName',
  //     key: 'rightsName',
  //     width: 200
  //   },
  //   {
  //     title: '权益保障金额',
  //     dataIndex: 'rightsValue',
  //     key: 'rightsValue'
  //   },
  //   {
  //     title: '权益说明',
  //     dataIndex: 'info',
  //     key: 'info'
  //   }
  // ]
}
// {
//   slots: {title: '保障期限'},
//   dataIndex: 'duration',
//   key: '2',
//   align: 'center',
//   scopedSlots: {customRender: 'duration'}
// },
// {slots: {title: '保费'}, dataIndex: 'price', key: '3', align: 'center'}
// {
//   slots: {title: '操作'},
//   dataIndex: 'action',
//   key: '5',
//   align: 'center',
//   scopedSlots: {customRender: 'action'},
//   width: 300
// }
];